import { Component, Vue } from 'vue-facing-decorator';
// @ts-ignore
import Cookies from 'js-cookie';
import { GOOGLE_MAP_KEY } from '@/helpers/auth';

const AVAILABLE_TYPE_GOOGLE = 'google';
const AVAILABLE_TYPE_LEAFLET = 'leaflet';
const AVAILABLE_MAPS_API = [AVAILABLE_TYPE_GOOGLE, AVAILABLE_TYPE_LEAFLET];

@Component
export default class MapsApi extends Vue {
    currentApi = Cookies.get(GOOGLE_MAP_KEY) ? AVAILABLE_TYPE_GOOGLE : AVAILABLE_TYPE_LEAFLET;

    get mapsApi_isGoogleMap(): boolean {
        return this.currentApi === AVAILABLE_TYPE_GOOGLE;
    }

    get mapsApi_isLeafletMap(): boolean {
        return this.currentApi === AVAILABLE_TYPE_LEAFLET;
    }
};
